import { API_BASE_URL } from '../config';

const apiRequest = async (endpoint, action, data = {}) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ action, ...data }),
        });
        return await response.json();
    } catch (error) {
        console.error(`API Error (${action}):`, error);
        return { success: false, message: error.message };
    }
};

export const adminApi = {
    // Projects
    getProjects: () => apiRequest('admin_actions.php', 'get_projects'),
    createProject: (data) => apiRequest('admin_actions.php', 'create_project', data),
    updateProject: (data) => apiRequest('admin_actions.php', 'update_project', data),
    deleteProject: (id) => apiRequest('admin_actions.php', 'delete_project', { id }),
    getCategories: () => apiRequest('admin_actions.php', 'get_project_categories'),
    resolveMapLink: (url) => apiRequest('admin_actions.php', 'resolve_map_link', { url }),

    // Admins/Members
    getAdmins: () => apiRequest('admin_actions.php', 'get_admins'),
    createAdmin: (data) => apiRequest('admin_actions.php', 'create_admin', data),
    updateAdmin: (data) => apiRequest('admin_actions.php', 'update_admin', data),
    deleteAdmin: (id) => apiRequest('admin_actions.php', 'delete_admin', { id }),

    // Attendance
    getProjectAttendance: (projectId) => apiRequest('admin_actions.php', 'get_project_attendance', { project_id: projectId }),
    getAllAttendance: () => apiRequest('admin_actions.php', 'get_all_attendance'),
    markAttendance: (data) => apiRequest('attendance.php', 'mark_attendance', data),

    // Clubs
    getClubs: (data) => apiRequest('admin_actions.php', 'get_clubs', data),
    createClub: (data) => apiRequest('admin_actions.php', 'create_club', data),
    updateClub: (data) => apiRequest('admin_actions.php', 'update_club', data),
    deleteClub: (lion_ID) => apiRequest('admin_actions.php', 'delete_club', { lion_ID }),

    // Sub-Districts
    getSubDistricts: () => apiRequest('admin_actions.php', 'get_sub_districts'),
    createSubDistrict: (data) => apiRequest('admin_actions.php', 'create_sub_district', data),
    updateSubDistrict: (data) => apiRequest('admin_actions.php', 'update_sub_district', data),
    deleteSubDistrict: (id) => apiRequest('admin_actions.php', 'delete_sub_district', { id }),

    // Reports
    getReports: (type) => apiRequest('admin_actions.php', 'get_reports', { type }),
};
